import React, { Component, forwardRef } from "react";

import {
  Overlay,
  Caption,
  Text,
  CtaButtonLink,
  HoverOverlay,
  Title, CardContent, StyledFigure, CardRatio, DealLabel, CardContentSkeleton, TextCardContent, TextContainer, CtaButton
} from "./styles";

import { CardProps, PredefinedColor, TextCardProps } from "./types";
import Image from "next/image";
import { getImage, getImageProp, CARD_GRID_2 } from "@itchannelplus/utils";
import { Link } from "../Link";
import { getReadableTextColor } from "@itchannelplus/utils";


export const Card = forwardRef(({
                                  image,
                                  caption,
                                  title,
                                  overlay,
                                  titleStyle,
                                  hideInMobile = false,
                                  noGradient = false,
                                  hideOverlay = false,
                                  imageRatio,
                                  deal = false,
                                  cta,
                                  children,
                                  style,
                                  link,
                                  sizes,
                                  textPosition = "bottom",
                                  textAlign,
                                  ...props
                                }: CardProps, ref) => {
  const ratio = imageRatio ? (typeof imageRatio == "string" ? imageRatio : "number") : "natural";
  const mergedStyle = ratio == "number" ? { paddingTop: (imageRatio as number * 100) + "%", ...style } : { ...style };
  const { href, ...linkProps } = link || {};
  const { refNumber, ...cardProps } = props;
  const imageSizes = sizes || (imageRatio != "natural" ? CARD_GRID_2 : undefined);
  return <CardContent ref={ref as any} deal={!!deal} style={mergedStyle} {...{ hideInMobile }}
                      hoverable={!hideOverlay && !!overlay} hoverAnim={!!link?.href} {...cardProps} >
    <CardRatio ratio={ratio}>
      <Link href={link?.href as any}  {...linkProps} >
        <StyledFigure gradient={!!image && !noGradient} textPosition={textPosition}>
          {!!deal && typeof deal == "string" && <DealLabel>{deal}</DealLabel>}
          {!!image && <Image src={getImage(image)}
                             width={getImageProp("width", image)}
                             height={getImageProp("height", image)}
                             alt={getImageProp("alt", image) || title || "Le Voyage"}
                             title={getImageProp("alt", image) || title || "Le Voyage"}
                             fill={imageRatio != "natural"} loading={"lazy"}
                             sizes={imageSizes} />}
          <Overlay textPosition={textPosition} textAlign={textAlign}>
            {!!title && !caption && <Title style={titleStyle}>{title}</Title>}
            {!!caption && !!title &&
              <>
                <Caption>{caption}</Caption>
                <Text style={titleStyle}>{title}</Text>
                {cta?.label && !cta.href && <CtaButton size={cta?.size || "normal"} color={cta?.color || "primary"} variant={cta?.variant || "solid"} label={cta?.label}></CtaButton>}
                {cta?.label && cta.href && <CtaButtonLink size={cta?.size || "normal"} color={cta?.color || "primary"} variant={cta?.variant || "solid"} label={cta?.label} href={cta.href}></CtaButtonLink>}
              </>}
            {!!children && children}
          </Overlay>
        </StyledFigure>
      </Link>
      {!hideOverlay && overlay && <HoverOverlay>
        {!!overlay.caption && <Caption>{overlay.caption}</Caption>}
        {!!overlay.text && <Text>{overlay.text}</Text>}
        {overlay?.cta?.label && overlay.cta.href &&
          <CtaButtonLink {...overlay.cta} size={overlay.cta.size || "normal"} color={overlay.cta.color || "light"} variant={overlay.cta.variant || "outline"} href={overlay.cta.href} label={overlay.cta.label}
                         target={overlay.cta.target}  />}
        {overlay?.cta?.label && !overlay.cta.href &&
          <CtaButton {...overlay.cta} size={overlay.cta.size || "normal"} color={overlay.cta.color || "light"} variant={overlay.cta.variant || "outline"} label={overlay.cta.label}
                         target={overlay.cta.target}  />}
      </HoverOverlay>}
    </CardRatio>
  </CardContent>;
});
Card.displayName = "Card";

export const CardSkeleton = ({
                               imageRatio,
                               style,
                               hideInMobile,
                               ...props
                             }: Pick<CardProps, "style" | "hideInMobile"> & Required<Pick<CardProps, "imageRatio">>) => {
  const ratio = imageRatio ? (typeof imageRatio == "string" ? imageRatio : "number") : "natural";
  const mergedStyle = ratio == "number" ? { paddingTop: (imageRatio as number * 100) + "%", ...style } : { ...style };
  return <CardContentSkeleton style={mergedStyle} {...{ hideInMobile }} {...props} >
    <CardRatio ratio={ratio}>

    </CardRatio>
  </CardContentSkeleton>;
};


export const TextCard = ( {
                            title,
                            text,
                            color = '#000000',
                            imageRatio,
                            style,
                            titleStyle,
                            textStyle,
                            hideInMobile,
                            active,
                            link,
                            ...props}: TextCardProps) => {
  const textColor = (color && color.startsWith('#')) ? getReadableTextColor(color) : 'inherit';
  const cardColor = !color.startsWith('#') ? color as PredefinedColor: undefined;
  const ratio = imageRatio ? (typeof imageRatio == "string" ? imageRatio : "number") : "natural";
  const mergedStyle = ratio == "number" ? { paddingTop: (imageRatio as number * 100) + "%", ...style} : { ...style};
  const mergedTitleStyle =  { ...titleStyle, color: textColor  };
  const mergedTextStyle =  { ...textStyle, color: textColor  };
  const { href, ...linkProps } = link || {};
  return <TextCardContent style={mergedStyle}  {...props}   >
        <CardRatio ratio={ratio}>
          <Link href={href as any}  {...linkProps} >
            <TextContainer color={cardColor} active={active}>
            <Title style={mergedTitleStyle}>{title}</Title>
            <Text style={mergedTextStyle}>{text}</Text>
            </TextContainer>
          </Link>
        </CardRatio>
  </TextCardContent>;
}

